import { NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithoutAuthorization,
  postApiWithAuthorization

} from "../ApiMethod/ApiMethod";



export const GetTempleDarshanDetailBySlug = async (AppLangID, slug) => {
  const url = `${NewUpdatedBaseUrl}/TempleDarshanBooking/GetTempleDarshanDetailBySlug?AppLangID=${AppLangID}&SlugName=${slug}`;
  const res = await getApiWithAuthorization(url);

  return res;
};

export const AddUpdateTempleDarshanBooking = async (params) => {
  const url = `${NewUpdatedBaseUrl}/TempleDarshanBooking/AddUpdateTempleDarshanBooking`;
  const res = await postApiWithAuthorization(url, params);
  return res;
};

export const GetTempleDarshanBookingList = async (params) => {
  const url = `${NewUpdatedBaseUrl}/TempleDarshanBooking/GetTempleDarshanBookingList`;
  const res = await postApiWithAuthorization(url, params);
  return res;
};


export const GetTempleDarshanBookingDetails = async (DarshanBookingKeyID) => {
  const url = `${NewUpdatedBaseUrl}/TempleDarshanBooking/GetTempleDarshanBookingDetails?DarshanBookingKeyID=${DarshanBookingKeyID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};

